var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAsset3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 208.44 214.23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#3d57a7;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M189.74,18.7a64,64,0,0,0-90.38,0C80.61,37.43,74.82,67,84.12,96.21L.49,179.81A1.73,1.73,0,0,0,0,181.09l1.63,30.23h0a1.66,1.66,0,0,0,1.6,1.57l32.93,1.34h.08a1.71,1.71,0,0,0,1.19-.48l7-7a1.62,1.62,0,0,0,.49-1.09l.63-10.91,2.13-2.12,10.83-.57h0a1.62,1.62,0,0,0,1.1-.49L68,183.12a1.72,1.72,0,0,0,.46-1.51l-2.24-11.35,2.5-2.51,11.64,2h0a1.7,1.7,0,0,0,1.47-.46l7.9-7.9h0a1.71,1.71,0,0,0,.45-1.58l-2.54-11,27.95-27.94a63.92,63.92,0,0,0,74.11-102.2ZM157.33,51.09a10.53,10.53,0,1,1,7.43,3.07,10.51,10.51,0,0,1-7.43-3.07Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAsset3);
export default __webpack_public_path__ + "static/media/Asset3.eacf9cd6fa827cb2a649bb1745353d7f.svg";
export { ForwardRef as ReactComponent };